import modelExtend from 'dva-model-extend'
import {model, delay} from './common'
import service from '../services/groupapply'

let countDownState = false

export default modelExtend(model, {

  namespace: 'groupapply',
  state: {
    groupProperties: [],
    countDown: 0,
    showSuccess: false,
  },
  subscriptions: {
    setupHistory({dispatch, history}) {
      history.listen((location) => {
        if (location.pathname === '/group-apply') {
          dispatch({
            type: 'init',
          })
        } else {
          countDownState = false
        }
      })
    },
  },
  effects: {

    * init({payload,}, {call, put, select}) {
      countDownState = false
      const {groupProperties} = yield select(_ => _['groupapply'])
      yield put({
        type: 'updateState',
        payload: {
          showSuccess: false,
          countDown: 0,
        }
      })
      if (groupProperties.length === 0) {
        const list = yield call(service.getGroupProperties)
        console.log(list)
        yield put({
          type: 'updateState',
          payload: {
            groupProperties: list,
          }
        })
      }
    },
    * sendVerifyCode({payload}, {call, put, select}) {

      yield call(service.sendVerifyCode, payload)

      // 60秒倒计时...
      let countDown = 60
      countDownState = true
      while (countDown > 0) {
        if (countDownState === false) {
          return
        }
        countDown--
        yield put({
          type: 'updateState',
          payload: {
            countDown
          }
        })
        yield call(delay, 1000);
      }
    },

    * submit({payload}, {call, put, select}) {
      const {groupApplyNo} = yield call(service.submit, payload)
      yield put({
        type: 'updateState',
        payload: {
          showSuccess: true,
          groupApplyNo,
        }
      })
    },
  },
})
